<script>
import _ from 'lodash'
import { mapGetters, mapActions } from "vuex";
import { _is } from '../mixins/_is'
import { getPlatformImage } from '../mixins/getPlatformImage'

export default {
  name: "gmailModal",
  mixins: [_is, getPlatformImage],
  components: {},
  props:{
    conversationId : {
      type: String
    },
    openedMessage : {
      type: Object
    }
  },
  methods: {
    ...mapActions("htmlModals", ["setConversationModal"]),
    closeModal(){
      this.setConversationModal(false); 
      //document.body.classList.remove('overflowYHidden');
      window.history.pushState('', '', '/inbox'); 
    }
  }

}
</script>

<template>
  <div id="scrollingContainer" class="modalWrapper">
    <div @click="closeModal()" class="modal"> </div>

      <div class="ui grid centered stackable">
      <div style="background: rgba(70, 70, 70, 0.34) none repeat scroll 0% 0%; z-index: 9999;border-radius: 10px;" class="fifteen wide column">
      <div class="ui grid">
        <div style="padding-right:0;" class="twelve wide computer sixteen wide mobile column">
        <div style="background: transparent; padding: 0; z-index: 9999999; " class="ui basic segment">
          <div v-if="modalInside" v-on:click.stop style="background: #f5f5f5;  border-color: #f0f0f0;" class="ui basic top attached segment">
            abahsbhjxab
          </div>
          </div>
          </div>
          </div>
          </div>
          </div>


  </div>
</template>

<style>
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}

.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/conversation/gmail.vue